import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort,DateAdapter,MAT_DATE_LOCALE,MAT_DATE_FORMATS } from '@angular/material';
import { Router } from '@angular/router';
import { DocumentoNegociableService } from '../../../services/documento-negociable/documento-negociable.service';
import { DatePipe } from "@angular/common";
import Swal from "sweetalert2";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MessagesTitles, MessagesGeneral, MessagesDates, MessagesStatus } from '../../../models/messages';
import { FiltrosDnxSubastar } from 'app/models/FiltrosDnxSubastar';
import { LoginService } from 'app/services/login/login.service';
import { environment } from 'environments/environment';

export const MY_FORMATS = {
    parse: {
      dateInput: "DD-MM-YYYY"
    },
    display: {
      dateInput: "DD-MM-YYYY",
      monthYearLabel: "MMM YYYY",
      dateA11yLabel: "LL",
      monthYearA11yLabel: "MMMM YYYY"
    }
};

@Component({
    selector: 'app-listado-documentos-xsubastar',
    templateUrl: './listado-documentos-xsubastar.component.html',
    styleUrls: ['./listado-documentos-xsubastar.component.scss'],
    providers: [MessagesTitles,MessagesGeneral,MessagesDates,MessagesStatus,
      DatePipe,
      {
        provide: DateAdapter,
        useClass: MomentDateAdapter,
        deps: [MAT_DATE_LOCALE]
      },
  
      { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    ]
})

export class ListadoDocumentosXSubastarComponent implements OnInit{

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_id_soles=environment.ID_GUIA_SOLES;
  Label_id_dolares=environment.ID_GUIA_DOLARES;
  DTOFiltrosDnxSubastar: FiltrosDnxSubastar = new FiltrosDnxSubastar();
  DocumentosNegociables:any = [];
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  pageSizeOptions = [15,20,30,50,100,200];
  dataSource :any; 
  loading:boolean;
  displayedColumns: string[] = ['checked','NombreComercialProv','NombreComercialAdq','TipoMoneda','VNPP','Cantidad'];
  constructor(private documentoNegociable:DocumentoNegociableService,
              private msgTitulos : MessagesTitles,
              private msgStatus:MessagesStatus,
              private loginService:LoginService,
              private router:Router){}

  ngOnInit(){
    this.ListadoDnSubasta();
  }

  ListadoDnSubasta(){
  this.loading = true;

  this.documentoNegociable.obtenerDocumentosxSubastar(this.DTOFiltrosDnxSubastar)
  .subscribe( resp => { 

  this.DocumentosNegociables= resp
  this.dataSource = new MatTableDataSource( this.DocumentosNegociables);
  this.dataSource.sort = this.sort;
  this.dataSource.paginator = this.paginator;
  this.loading = false;
 
 
 }, (err)=> {
  this.loading = false;
  if (err.error instanceof ErrorEvent) {
    console.error("Error Event");
  } else {
    this.msgStatus.getMessage(err.status);            
  }
 Swal.fire({
   title: this.msgTitulos.Error,
   text: "LISTA NO OBTENIDA. "+this.msgStatus.message,
   type: "error",
   allowOutsideClick: false,
   heightAuto: false
 });
})  
}

  subastar(elemento : any){
    this.loginService.clickGuard = true;
    this.documentoNegociable.datosxsubastar = elemento;
    this.router.navigate(["/riesgo/dnsubasta/nuevo"]);
  }
}